import { BaseIdentity } from './base-identity';
import { DomainModelSerialCollection } from './domain-model-serial-collection';
import { BaseRowNumberModel } from './base-row-number-model';


export abstract class DomainModelSerialRowNumberCollection<TItem extends BaseRowNumberModel<TIdentity>, TIdentity extends BaseIdentity>
    extends DomainModelSerialCollection<TItem, TIdentity> {

}
